import { CameraDetectorService } from '@services/camera-detector.service';
import { FaceTracker } from '@services/face-tracker';
import { MediaPipeTrackerService } from '@services/media-pipe-tracker.service';
import { NativeFaceTrackerService } from '@services/native-face-tracker.service';

export function detectCamera(cameraDetectorService: CameraDetectorService) {
  return () => cameraDetectorService.detectNativeCamera();
}

export function getFaceTracker(cameraDetectorService: CameraDetectorService): FaceTracker {
  if (cameraDetectorService.nativeCameraAvailable) {
    return new NativeFaceTrackerService();
  }
  return new MediaPipeTrackerService();
}
